module.exports = __webpack_public_path__ + "static/img/logo.ad48da32.png";